import back5 from "../../../../imgs/back5.png";
import { useNavigate } from "react-router-dom";
import Nav from "../../vendor/navbar";
import Main from "./listing";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
const Listing = () => {
  const dispatch = useDispatch();
  const router = useNavigate();
  const user = useSelector((state) => state.user);
  const SelectedOrderFlow = useSelector((state) => state.SelectedOrderFlow);
 const QuotationFlow =useSelector((state) => state.QuotationFlow);

  useEffect(() => {
    if (QuotationFlow) {
      return;
    }

    dispatch({
      type: "PLACE_ORDER_DATA",
      num: {},
    });
    dispatch({ type: "PRODUCT_TAXES", num: [] });
    dispatch({ type: "Cart", num: [] });
    dispatch({ type: "SELECTED_COMPANY_VENDOR", num: null });
    dispatch({ type: "SELECTED_BRANCH_VENDOR", num: null });
    // dispatch({ type: "QUOTATION_FLOW", num: false });
  }, []);

  return (
    <>
      <div className="bg-[#D9EFED] min-h-screen">
        <Nav />
        <div className="flex items-center justify-center  ">
          <div className="sm:w-[95%]  mt-[1rem] sm:px-10 px-6 rounded-md mb-12">
            <div className="cursor-pointer flex w-full items-center justify-center">
              <img
                onClick={() => {
                  if (user === "vendor-owner") {
                    router("/VendorDashboard");
                    return;
                  }

                  if (SelectedOrderFlow?.title === "Search Product") {
                    router("/Inventory/SelectOption");
                    return;
                  }

                  // if (user !== "vendor") router("/superAdminDashboard");
                  else router("/SuperAdmin/InventoryDashboard");
                }}
                className="sm:w-[1.7rem] w-[1.3rem]"
                src={back5}
                alt=""
              />
              <h2 className="font-bold w-full sm:text-[1.8rem] sm:ml-2 ml-[1rem] text-[1.4rem]">
                Select Product
              </h2>
            </div>

            {/* <div className="bg-[#F6F4F4] mt-6 rounded-md p-8 mx-10"> */}
            <Main />
            {/* </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Listing;
